import { put } from "redux-saga/effects";
import http from "~/utils/config/http";
import {
  PORTALRH_MIDDLEWARE,
  RH_MIDDLEWARE,
  IFLOW_APP,
} from "~/utils/constants";

import {
  setBirthdayInfo,
  setNewColaboratorsInfo,
  setProfileData,
  setUpdateProfileData,
} from "./actionTypes";

import { activeError } from "~/components/Messages/actions";

export function* getBirthdayInfo() {
  try {
    const resp = yield http.get("api/colaboradores/birthdays", RH_MIDDLEWARE);
    yield put(setBirthdayInfo(resp.data));
  } catch (e) {
    yield put(setBirthdayInfo([]));
    yield put(activeError(e));
  }
}

export function* getNewColaboratorsInfo() {
  try {
    const resp = yield http.get("api/colaboradores/admission", RH_MIDDLEWARE);
    yield put(setNewColaboratorsInfo(resp.data));
  } catch (e) {
    yield put(setNewColaboratorsInfo([]));
    yield put(activeError(e));
  }
}

export function* getProfileData({funcNum, codEmp}) {
  try {
    const resp = yield http.get(
      `api/profile/${codEmp}/${funcNum}`,
      RH_MIDDLEWARE
    );
    yield put(setProfileData(resp.data));
  } catch (e) {
    yield put(setProfileData({}));
    yield put(activeError(e));
  }
}

export function* updateProfileData({payload}) {
  try {
    const resp = yield http.post(
      "api/profile/insert",
      payload,
      RH_MIDDLEWARE
    );
    yield put(setUpdateProfileData(resp.data));
  } catch (e) {
    yield put(setUpdateProfileData([]));
    yield put(activeError(e));
  }
}
